import { useState, useEffect } from 'react'
import AuthService from 'services/auth'
import cutileiApi from 'services/cutileiApi'
import { logApiError } from 'services/apiError'
import CustomerService from 'services/Customer'
import BusinessNavbar from 'components/Navbars/BusinessNavbar'
import AddCustomerModal from 'pages/Modals/AddCustomerModal'
import MergeCustomersModal from 'pages/Modals/MergeCustomersModal'
import TextInput from 'components/Inputs/TextInput'
import CustomerList from 'components/Lists/CustomerList'
import SecondaryButton from 'components/Buttons/SecondaryButton'
import { ReactComponent as Loading } from 'icons/loading2.svg'
import { Container, Row, Title } from './styles'

export default function Customers () {
  const [loading, setLoading] = useState (true)
  const [query, setQuery] = useState ('')
  const [page, setPage] = useState (1)
  const [lastPage, setLastPage] = useState (0)
  const [total, setTotal] = useState (0)
  const [customers, setCustomers] = useState ([])
  const [showAddCustomerModal, setShowAddCustomerModal] = useState (false)
  const [showMergeCustomersModal, setShowMergeCustomersModal] = useState (false)
  const businessId = AuthService.getBusinessId ()
  const token = AuthService.getToken ()

  const requestConfig = {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  }

  useEffect (() => {
    getCustomers (1)
  }, [query])

  const getCustomers = async (pageNumber = page, _query = query)  => {
    if (lastPage && pageNumber > lastPage) return

    try {
      const { data: customersResponse } = await cutileiApi.get (
        `/businesses/${businessId}/customers?page=${pageNumber}&query=${encodeURIComponent (_query)}`,
        requestConfig
      )
      
      const { data, meta } = customersResponse
      const customersData = pageNumber > 1 ? [...customers, ...data] : data
      const sortedCustomers = CustomerService.sortCustomersByQuery (customersData, _query)

      setCustomers (sortedCustomers)
      setPage (pageNumber + 1)
      setLastPage (meta.last_page)
      setTotal (meta.total)
    } catch (error) {
      logApiError (error)
    } finally {
      setLoading (false)
    }
  }

  const toggleAddCustomerModal = () => setShowAddCustomerModal (!showAddCustomerModal)
  const toggleMergeCustomersModal = () => setShowMergeCustomersModal (!showMergeCustomersModal)

  return (
    <Container>
      <BusinessNavbar/>
      <Title>Clientes</Title>
      <Row>
        <TextInput
          value={query}
          placeholder='Pesquisar por nome, e-mail ou celular'
          isClearable={true}
          onChange={e => setQuery (e.target.value)}
          onClear={() => {
            setQuery ('')
            getCustomers (1, '')
          }}
          containerStyle={{width: 300}}
          inputStyle={{boxShadow: '0px 1px 10px -6px', paddingInline: 12}}
        />
        {AuthService.hasPermission ('customers', 'edit') && (
          <>
            <SecondaryButton
              label='Cadastrar cliente'
              onClick={toggleAddCustomerModal}
              width={150}
            />
            <SecondaryButton
              label='Unificar clientes'
              onClick={toggleMergeCustomersModal}
              width={150}
            />
            <AddCustomerModal
              visible={showAddCustomerModal}
              query={query}
              onConfirm={customer => setCustomers ([...customers.filter (c => c.id !== customer.id), customer])}
              onClose={toggleAddCustomerModal}
            />
            <MergeCustomersModal
              visible={showMergeCustomersModal}
              onClose={toggleMergeCustomersModal}
            />
          </>
        )}
      </Row>
      {loading ? <Loading style={{marginTop: 30}}/> :
        <CustomerList
          customers={customers}
          totalCustomers={total}
          hasMore={!(lastPage && page > lastPage)}
          onScroll={() => getCustomers ()}
          onEdit={customer => setCustomers (customers.map (c => c.id === customer.id ? {...customer} : c))}
          onDelete={customer => setCustomers (customers.filter (c => c.id !== customer.id))}
        />
      }
    </Container>
  )
}
